import React, { useRef } from 'react';
import { Control, FieldErrors } from 'react-hook-form';
import { GetCoachSettingsQuery } from 'types/generated/client';
import EditSchedule from 'screens/MySchedule/EditSchedule';
import ProfileItem from 'components/coaches-builder/ProfileItem';
import Switcher from 'components/forms/Switcher';
import classNames from 'styles/utils/classNames';

interface DirectBookingContentProps {
  control: Control<any>;
  errors: FieldErrors<any>;
  directBookings: boolean;
  coachData?: GetCoachSettingsQuery['usersByPk'];
  timeSlotFormRef: React.MutableRefObject<any>;
  visible: boolean;
  priceInputField: React.ReactNode | null;
}

const DirectBookingContent: React.FC<DirectBookingContentProps> = ({
  control,
  errors,
  directBookings,
  coachData,
  timeSlotFormRef,
  visible,
  priceInputField,
}) => {
  return (
    <div className={classNames('flex flex-col', visible ? 'flex' : 'hidden')}>
      <div className="typography-product-subheading relative mb-[3.75rem] mt-9 w-full shrink-0 text-center text-color-text-lightmode-icon dark:text-color-text-darkmode-icon">
        <p className="mb-0">Players can book directly from your calendar.</p>
        <p>Players will not be able to book group clinics until you make them available.</p>
      </div>

      {priceInputField && (
        <ProfileItem
          customClass="!mt-0 max-md:mx-0"
          label="Private lesson cost"
          description="Even if you don't offer private lessons, this will help players understand the general cost of your services."
          hasBottomBorder={true}
          invert
          component={priceInputField}
        />
      )}

      <ProfileItem
        label="Direct bookings (Free calendar slots)"
        customClass="max-md:mx-0"
        description="This applies to individual lessons only. Players will not be able to book group clinics until you make them available."
        helperText="Bounce can drive new players to my profile to book directly."
        hasBottomBorder={directBookings}
        invert
        component={
          <div className="w-fit">
            <Switcher
              errors={errors}
              control={control}
              name="directBookings"
              classNameLabel="text-nowrap"
              brand
              invert
            />
          </div>
        }
      />

      <ProfileItem
        customClass={classNames('max-md:mx-0', !directBookings && 'hidden')}
        label="Set up your schedule"
        description="Your availability is what players will see before booking a lesson. You will be able to change this whenever you would like."
        hasBottomBorder={true}
        invert
        component={
          <EditSchedule
            schedule={coachData?.coachAvailability}
            inDrawer={false}
            ref={timeSlotFormRef}
            wrapperClassName=""
            invert
          />
        }
      />
    </div>
  );
};

export default DirectBookingContent;
